import(/* webpackMode: "eager" */ "/home/ubuntu/download/698587d8921dc90014dd04b1/guzmanrodriguez/src/app/calculator/page.tsx");
